const translations = {
  // Navigation
  "nav.home": "Início",
  "nav.about": "Sobre",
  "nav.specialties": "Especialidades",
  "nav.team": "Time",
  "nav.blog": "Blog",
  "nav.contact": "Contato",
  "nav.schedule": "Agendar Consulta",

  // Hero
  "hero.title": "Tax Preparation que Você Pode Confiar nos Estados Unidos",
  "hero.subtitle": "Impostos pessoais e empresariais para brasileiros residentes nos EUA, com atendimento em português, clareza e segurança.",
  "hero.description": "Cuidamos das suas taxes com precisão, organização e total conformidade com as leis americanas, para você ter tranquilidade e evitar problemas com o IRS.",
  "hero.cta": "Agendar Consulta",
  "hero.whatsapp": "Falar com Especialista",

  // Results
  "results.title": "Números Acumulados ao Longo dos Anos de Atuação",
  "results.individual": "Declarações Individuais Entregues",
  "results.business": "Declarações Empresariais Entregues",

  // Testimonials
  "testimonials.badge": "Google Reviews",
  "testimonials.title": "O Que Nossos Clientes Dizem",
  "testimonials.description": "A confiança de quem já passou pela Amiraco é a nossa maior prova de qualidade",
  "testimonials.verified": "Todos os depoimentos são reais e verificados do Google Reviews",
  "testimonials.satisfied": "Clientes satisfeitos",
  "testimonials.recommend": "Recomendariam",
  "testimonials.viewGoogle": "Ver no Google",
  "testimonials.basedOn": "Baseado em",
  "testimonials.reviewsOn": "avaliações no Google",

  // About
  "about.title": "Sobre a Amiraco",
  "about.p1": "A Amiraco Tax Service é uma empresa especializada em serviços fiscais e contábeis nos Estados Unidos, com mais de 11 anos de experiência atendendo pessoas físicas e empresas. Atuamos com foco em precisão, conformidade fiscal e atendimento personalizado, oferecendo soluções completas para quem busca segurança e tranquilidade na gestão de seus impostos.",
  "about.p2": "Prestamos serviços que vão desde a preparação e entrega de declarações de imposto de renda (Tax Return) até consultoria e planejamento tributário para empresas de diferentes portes e segmentos. Nossos processos são organizados, transparentes e totalmente alinhados à legislação americana, garantindo eficiência e confiança em cada etapa.",
  "about.p3": "Somos Enrolled Agent (EA), credenciados pelo IRS para representar contribuintes perante o órgão fiscal, além de Acceptance Agent autorizado para serviços de ITIN. Isso nos permite conduzir processos fiscais com alto nível técnico, segurança e agilidade, sem a necessidade de envio de documentos originais ao IRS.",
  "about.credential1": "Enrolled Agent (EA) credenciado pelo IRS",
  "about.credential2": "Acceptance Agent autorizado para ITIN (sem envio de documentos originais ao IRS)",
  "about.credential3": "Processos organizados e transparentes alinhados à legislação americana",

  // Specialties
  "specialties.title": "Nossas Especialidades",
  "specialties.description": "Oferecemos uma gama completa de serviços fiscais e contábeis para atender todas as suas necessidades",
  "specialties.individual": "Serviços para Pessoa Física",
  "specialties.business": "Serviços para Empresas e Autônomos",
  
  "specialties.taxReturn.title": "Declaração de Imposto",
  "specialties.taxReturn.desc": "Tax Return completo para Individual e Family, com análise detalhada e maximização de restituições",
  "specialties.taxExtension.title": "Extensão de Imposto",
  "specialties.taxExtension.desc": "Tax Extension para garantir mais tempo no preparo da sua declaração sem penalidades",
  "specialties.itin.title": "ITIN – Solicitação e Renovação",
  "specialties.itin.desc": "Acceptance Agent autorizado - autenticação de passaporte sem envio ao IRS",
  "specialties.consulting.title": "Consultoria Fiscal",
  "specialties.consulting.desc": "Orientação especializada sobre questões tributárias para tomada de decisões estratégicas",
  "specialties.notary.title": "Notary Public",
  "specialties.notary.desc": "Serviços completos de notarização de documentos com validade legal",
  "specialties.passport.title": "Renovação de Passaporte",
  "specialties.passport.desc": "Assistência completa na renovação do seu passaporte brasileiro em período de baixa temporada de taxas",
  
  "specialties.company.title": "Abertura de Empresa",
  "specialties.company.desc": "Assessoria completa para abertura de LLC e S Corp nos EUA com escolha do melhor regime tributário",
  "specialties.bookkeeping.title": "Contabilidade Mensal",
  "specialties.bookkeeping.desc": "Bookkeeping completo com gestão contábil, escrituração e demonstrações financeiras",
  "specialties.payroll.title": "Payroll (Folha de Pagamento)",
  "specialties.payroll.desc": "Gestão completa de folha de pagamento e benefícios para sua empresa",
  "specialties.businessConsulting.title": "Consultoria Fiscal Empresarial",
  "specialties.businessConsulting.desc": "Estratégias legais para redução de carga tributária e otimização fiscal do seu negócio",
  "specialties.selfEmployed.title": "Organização Fiscal para Autônomos",
  "specialties.selfEmployed.desc": "Serviços especializados para Self-Employed com organização completa da documentação fiscal",
  "specialties.regularization.title": "Regularização Fiscal",
  "specialties.regularization.desc": "Resolução de pendências fiscais e regularização de situação tributária junto ao IRS",
  "specialties.irsNotices.title": "IRS Notices",
  "specialties.irsNotices.desc": "Análise e resposta profissional a notificações do IRS com representação autorizada",
  "specialties.1099.title": "Emissão de 1099s",
  "specialties.1099.desc": "Preparação e envio de formulários 1099 para contratados independentes e prestadores de serviços",

  // CTA
  "cta.title": "Pronto para Regularizar sua Situação Fiscal nos EUA?",
  "cta.description": "Agende uma consulta gratuita e descubra como podemos ajudar você ou sua empresa",
  "cta.button": "Agendar Consulta Gratuita",

  // Team
  "team.title": "Conheça Nossa Equipe",
  "team.description": "Profissionais experientes e dedicados ao seu sucesso",
  "team.support": "Time de Suporte",
  "team.victor.role": "Enrolled Agent",
  "team.victor.education": "Formado em Berkeley",
  "team.victor.desc": "Especialista em atendimento empresarial, com ampla experiência em planejamento tributário e consultoria fiscal para empresas de todos os portes",
  "team.denise.role": "Especialista em Tax Preparation",
  "team.denise.education": "Certificação CTEC",
  "team.denise.desc": "Especialista em pessoa física, com foco em declarações de imposto de renda, ITIN e serviços para brasileiros nos EUA",
  "team.assistant": "Assistente",

  // Blog
  "blog.title": "Últimas do Blog",
  "blog.description": "Fique por dentro das novidades fiscais e dicas para sua empresa nos EUA",
  "blog.viewAll": "Ver Todos os Artigos",
  "blog.post1.title": "Tax Return 2024: Principais Mudanças para Brasileiros",
  "blog.post1.desc": "Confira as principais alterações na declaração de imposto de renda nos EUA para este ano e evite problemas com o IRS",
  "blog.post2.title": "Como Solicitar ITIN sem Enviar Passaporte ao IRS",
  "blog.post2.desc": "Descubra como nosso serviço de Acceptance Agent facilita a solicitação do seu ITIN com segurança",
  "blog.post3.title": "LLC ou S Corp: Qual Escolher para Sua Empresa?",
  "blog.post3.desc": "Guia completo sobre como abrir uma empresa nos EUA e escolher o melhor regime tributário",

  // Contact
  "contact.title": "Entre em Contato",
  "contact.description": "Estamos prontos para atender você. Entre em contato conosco e agende sua consulta gratuita hoje mesmo!",
  "contact.phone": "Telefone",
  "contact.email": "E-mail",
  "contact.address": "Endereço",
  "contact.hours": "Horário de Atendimento",
  "contact.hoursWeekday": "Segunda a Sexta: 9:00 AM – 6:00 PM",
  "contact.hoursWeekend": "Após este horário e aos sábados:",
  "contact.hoursScheduled": "Somente com horário agendado",
  "contact.reviewsOn": "avaliações no Google",
  
  "contact.form.title": "Envie sua Mensagem",
  "contact.form.name": "Nome Completo",
  "contact.form.namePlaceholder": "Seu nome completo",
  "contact.form.phone": "Telefone",
  "contact.form.phonePlaceholder": "(11) 99999-9999",
  "contact.form.email": "E-mail",
  "contact.form.emailPlaceholder": "seu@email.com",
  "contact.form.reason": "Motivo do Contato",
  "contact.form.reasonPlaceholder": "Selecione uma opção",
  "contact.form.message": "Mensagem",
  "contact.form.messagePlaceholder": "Descreva como podemos ajudar você...",
  "contact.form.characters": "caracteres",
  "contact.form.submit": "Enviar Mensagem",
  "contact.form.sending": "Enviando...",
  "contact.form.success": "Mensagem enviada com sucesso! Entraremos em contato em breve.",
  "contact.form.error": "Erro ao enviar mensagem. Por favor, tente novamente.",
  "contact.form.required": "Por favor, preencha todos os campos obrigatórios.",
  "contact.form.maxLength": "A mensagem não pode exceder 500 caracteres.",

  // Certifications
  "certifications.badge": "Credenciais Oficiais",
  "certifications.title": "Nossas Certificações",
  "certifications.description": "Profissionais credenciados e autorizados pelos principais órgãos fiscais dos Estados Unidos",
  "certifications.ea.title": "Enrolled Agent (EA)",
  "certifications.ea.desc": "Credenciado pelo IRS para representar contribuintes em questões fiscais perante o governo federal",
  "certifications.ea.issuer": "U.S. Department of the Treasury",
  "certifications.efile.title": "IRS Authorized e-File Provider",
  "certifications.efile.desc": "Provedor autorizado pelo IRS para envio eletrônico de declarações de imposto de renda",
  "certifications.efile.issuer": "Internal Revenue Service",
  "certifications.acceptance.title": "Acceptance Agent",
  "certifications.acceptance.desc": "Agente autorizado pelo IRS para autenticação de documentos e solicitação de ITIN",
  "certifications.acceptance.issuer": "IRS ITIN Program",
  "certifications.ctec.title": "CTEC – California",
  "certifications.ctec.desc": "Certificação do California Tax Education Council para preparação de impostos no estado da Califórnia",
  "certifications.ctec.issuer": "State of California",

  // Footer
  "footer.description": "Soluções fiscais e contábeis especializadas para brasileiros nos EUA há mais de 11 anos.",
  "footer.navigation": "Navegação",
  "footer.mainServices": "Serviços Principais",
  "footer.quickContact": "Contato Rápido",
  "footer.copyright": "© 2024 Amiraco Tax Service. Todos os direitos reservados.",

  // Mobile CTA
  "mobile.call": "Ligar Agora",

  // TaxDome
  "taxdome.badge": "Portal Seguro Homologado pelo IRS",
  "taxdome.title": "TaxDome Client Portal",
  "taxdome.description": "A forma mais segura e prática de enviar seus documentos fiscais. Plataforma homologada pelo IRS com criptografia de ponta.",
  "taxdome.loginTitle": "Acesse Sua Conta",
  "taxdome.loginDesc": "Faça login no portal do cliente para enviar documentos, acompanhar o status da sua declaração e se comunicar conosco de forma segura.",
  "taxdome.loginButton": "Acessar Portal do Cliente",
  "taxdome.appTitle": "Baixe o App TaxDome",
  "taxdome.appDesc": "Tenha acesso ao portal na palma da mão. Envie documentos, receba notificações e acompanhe tudo pelo celular.",
  "taxdome.downloadOn": "Baixar na",
  "taxdome.getItOn": "Disponível no",
  "taxdome.feature1Title": "Criptografia Avançada",
  "taxdome.feature1Desc": "Seus dados protegidos com tecnologia de ponta",
  "taxdome.feature2Title": "Envio Seguro de Documentos",
  "taxdome.feature2Desc": "Mais seguro que e-mail ou WhatsApp",
  "taxdome.feature3Title": "Homologado pelo IRS",
  "taxdome.feature3Desc": "Plataforma certificada e em conformidade",

  // Tutorial TaxDome
  "tutorial.backHome": "Voltar ao Início",
  "tutorial.accessPortal": "Acessar Portal",
  "tutorial.badge": "Tutorial Completo",
  "tutorial.heroTitle": "Como Usar o Portal TaxDome",
  "tutorial.heroDesc": "Aprenda passo a passo como enviar seus documentos de forma segura, acompanhar sua declaração e se comunicar conosco através do portal.",
  "tutorial.loginNow": "Fazer Login Agora",
  "tutorial.downloadApp": "Baixar o App",

  "tutorial.whyTitle": "Por Que Usar o TaxDome?",
  "tutorial.whyDesc": "O TaxDome é a forma mais segura e eficiente de gerenciar seus documentos fiscais",
  "tutorial.why1Title": "100% Seguro",
  "tutorial.why1Desc": "Criptografia de ponta a ponta protege todos os seus documentos e informações pessoais",
  "tutorial.why2Title": "Economize Tempo",
  "tutorial.why2Desc": "Envie documentos em segundos, sem precisar ir ao escritório ou enviar por correio",
  "tutorial.why3Title": "Homologado pelo IRS",
  "tutorial.why3Desc": "Plataforma certificada e em total conformidade com as exigências do governo americano",

  "tutorial.stepsTitle": "Passo a Passo Completo",
  "tutorial.stepsDesc": "Siga estas instruções simples para usar o portal TaxDome",
  "tutorial.stepLabel": "Passo",
  "tutorial.prevStep": "Anterior",
  "tutorial.nextStep": "Próximo",

  "tutorial.step1.title": "Acesse o Portal",
  "tutorial.step1.desc": "Entre no portal do cliente usando suas credenciais de acesso.",
  "tutorial.step1.detail1": "Acesse amiracotax.taxdome.com ou clique no botão \"Acessar Portal\"",
  "tutorial.step1.detail2": "Digite seu e-mail e senha cadastrados",
  "tutorial.step1.detail3": "Se for seu primeiro acesso, você receberá um convite por e-mail com instruções",

  "tutorial.step2.title": "Navegue pelo Dashboard",
  "tutorial.step2.desc": "Conheça as principais áreas do portal e suas funcionalidades.",
  "tutorial.step2.detail1": "No menu lateral, acesse \"Documentos\" para ver e enviar arquivos",
  "tutorial.step2.detail2": "Em \"Tarefas\", veja o que precisa ser feito e os prazos",
  "tutorial.step2.detail3": "Use \"Mensagens\" para se comunicar diretamente conosco",

  "tutorial.step3.title": "Envie Seus Documentos",
  "tutorial.step3.desc": "Faça upload dos seus documentos fiscais de forma segura.",
  "tutorial.step3.detail1": "Clique em \"Documentos\" e depois em \"Fazer Upload\"",
  "tutorial.step3.detail2": "Arraste os arquivos ou clique para selecionar do seu computador",
  "tutorial.step3.detail3": "Você pode enviar W-2, 1099, recibos e qualquer documento necessário",

  "tutorial.step4.title": "Comunique-se Conosco",
  "tutorial.step4.desc": "Tire dúvidas e receba atualizações através do chat seguro.",
  "tutorial.step4.detail1": "Acesse \"Mensagens\" para enviar perguntas ou informações",
  "tutorial.step4.detail2": "Receba notificações quando respondermos",
  "tutorial.step4.detail3": "Todo o histórico fica salvo para sua referência",

  "tutorial.step5.title": "Assine Documentos",
  "tutorial.step5.desc": "Assine sua declaração e outros documentos eletronicamente.",
  "tutorial.step5.detail1": "Quando sua declaração estiver pronta, você receberá uma notificação",
  "tutorial.step5.detail2": "Revise o documento e clique em \"Assinar\"",
  "tutorial.step5.detail3": "A assinatura eletrônica tem validade legal e é aceita pelo IRS",

  "tutorial.appTitle": "Baixe o App TaxDome",
  "tutorial.appDesc": "Tenha o portal na palma da sua mão. Envie documentos, receba notificações e acompanhe tudo pelo celular.",
  "tutorial.downloadOn": "Baixar na",
  "tutorial.getItOn": "Disponível no",
  "tutorial.app.feature1": "Notificações Push",
  "tutorial.app.feature1Desc": "Saiba imediatamente quando algo precisa da sua atenção",
  "tutorial.app.feature2": "Escaneie Documentos",
  "tutorial.app.feature2Desc": "Use a câmera do celular para digitalizar documentos",
  "tutorial.app.feature3": "Chat em Tempo Real",
  "tutorial.app.feature3Desc": "Comunique-se conosco de qualquer lugar",
  "tutorial.app.feature4": "Acesso Seguro",
  "tutorial.app.feature4Desc": "Autenticação biométrica para máxima segurança",

  "tutorial.faqTitle": "Perguntas Frequentes",
  "tutorial.faqDesc": "Respostas para as dúvidas mais comuns sobre o portal TaxDome",
  "tutorial.faq.q1": "Como faço para criar minha conta no TaxDome?",
  "tutorial.faq.a1": "Você receberá um convite por e-mail da Amiraco Tax Service. Clique no link do convite e siga as instruções para criar sua senha. Se não recebeu o convite, entre em contato conosco.",
  "tutorial.faq.q2": "Esqueci minha senha. Como recupero?",
  "tutorial.faq.a2": "Na página de login, clique em \"Esqueci minha senha\" e digite seu e-mail. Você receberá um link para redefinir sua senha. Se tiver problemas, entre em contato conosco.",
  "tutorial.faq.q3": "Quais tipos de arquivos posso enviar?",
  "tutorial.faq.a3": "Você pode enviar PDF, imagens (JPG, PNG), documentos do Word e Excel. O tamanho máximo por arquivo é de 25MB. Para arquivos maiores, entre em contato conosco.",
  "tutorial.faq.q4": "O portal é realmente seguro?",
  "tutorial.faq.a4": "Sim! O TaxDome usa criptografia de ponta a ponta, a mesma tecnologia usada por bancos. A plataforma é homologada pelo IRS e atende a todos os requisitos de segurança de dados.",
  "tutorial.faq.q5": "Posso acessar o portal pelo celular?",
  "tutorial.faq.a5": "Sim! Você pode acessar pelo navegador do celular ou baixar o app TaxDome na App Store (iPhone) ou Google Play (Android) para uma experiência ainda melhor.",

  "tutorial.ctaTitle": "Pronto para Começar?",
  "tutorial.ctaDesc": "Acesse o portal agora e envie seus documentos de forma segura. Se precisar de ajuda, estamos à disposição!",
  "tutorial.needHelp": "Precisa de Ajuda?"
};

export default translations;
